import React from 'react';
import { callMultiple } from '../../utils';
import { Button } from '../Button';
import { useModalContext } from './ModalContext';
export function ModalCloseButton(props) {
    const { onClick, variant = 'secondary' } = props;
    const { onClose } = useModalContext();
    return (React.createElement(Button, { ...props, variant: variant, onClick: callMultiple((e) => e.stopPropagation(), onClick, onClose) }));
}
ModalCloseButton.displayName = 'Modal.CloseButton';
//# sourceMappingURL=ModalCloseButton.js.map